(() => {
  const root = document.querySelector('#lc-gallery-builder');
  if (!root || root.dataset.mobileControls === 'ready') return;
  root.dataset.mobileControls = 'ready';
  const wall = root.querySelector('#lc-free-wall');
  const add = root.querySelector('#lc-builder-add');
  const picker = root.querySelector('#lc-picker');
  if (!wall || !add || !picker) return;
  const returnToWall = () => {
    if (matchMedia('(max-width:899px)').matches && root.dataset.mode === 'builder') {
      root.querySelector('#lc-free-wall-wrap').scrollIntoView({block:'start', behavior:'instant'});
    }
  };
  const back = document.createElement('button');
  back.type = 'button';
  back.className = 'lc-text-button lc-mobile-wall-return';
  back.textContent = wall.getAttribute('aria-label');
  back.addEventListener('click', returnToWall);
  add.after(back);
  picker.addEventListener('close', returnToWall);
  const updateReplacementNote = () => {
    if (!picker.open || root.querySelector('#lc-picker-title')?.textContent.trim() !== 'Choose a replacement print.') return;
    const note = root.querySelector('#lc-picker-note');
    if (note) note.textContent = 'Replace this print while keeping its place on your wall. If the new size needs more room, positions may adjust to prevent overlap.';
  };
  new MutationObserver(updateReplacementNote).observe(picker, {attributes:true, attributeFilter:['open']});
  updateReplacementNote();
  root.querySelector('#lc-items').addEventListener('click', event => {
    const button = event.target.closest('button');
    if (button && button.textContent.trim() === 'Position') returnToWall();
  });
})();
